import React from 'react';
import { Button, Col, Row, Space, Tag, Typography } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, FileAddOutlined, RollbackOutlined } from '@ant-design/icons';
import { TReceiptData } from '../../../../models/salesModel';
import ReceiptPDFPrint from '../../../ReceiptPDFPrint';
import InvoicePDFDoc from '../../../InvoicePDFDoc';
import { getDocumentStatus } from './billDetailHelpers';

const { Title } = Typography;

interface BillDetailHeaderBarProps {
  title: string;
  documentNumber?: string | null;
  status?: string | null;
  isSettled: boolean;
  documentData: TReceiptData;
  isCreateNoteDisabled: boolean;
  onBack: () => void;
  onCreateNote: () => void;
}

export const BillDetailHeaderBar: React.FC<BillDetailHeaderBarProps> = ({
  title,
  documentNumber,
  status,
  isSettled,
  documentData,
  isCreateNoteDisabled,
  onBack,
  onCreateNote
}) => {
  return (
    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 24 }}>
      <Col flex="auto">
        <Space align="center">
          <Button icon={<RollbackOutlined />} onClick={onBack} />
          <Title level={3} style={{ margin: 0 }}>{title} {documentNumber}</Title>
          <Tag color="green">{getDocumentStatus(status || '')}</Tag>
          {isSettled ? (
            <Tag color="success" icon={<CheckCircleOutlined />} style={{ fontWeight: 600 }}>
              100% LIQUIDADA
            </Tag>
          ) : (
            <Tag color="processing" icon={<ClockCircleOutlined />}>
              CICLO EN CURSO
            </Tag>
          )}
        </Space>
      </Col>
      <Col>
        <Space>
          <ReceiptPDFPrint receipt={documentData} />
          <InvoicePDFDoc invoice={documentData} />
          <Button 
            type="primary" 
            icon={<FileAddOutlined />} 
            disabled={isCreateNoteDisabled}
            onClick={onCreateNote}
          >
            Crear Nota
          </Button>
        </Space>
      </Col>
    </Row>
  );
};
